<template>
  <div v-if="display">
    <modal-layout-top :title="title"/>
    <div class="content slider-modal">
      <div class="slider-modal-fields">
        <div class="field">
          <label class="label">Namn *</label>
          <input class="input" type="text" v-model="cust.name" />
        </div>

        <div class="field">
          <label class="label">Kundtyp</label>
          <div class="select">
            <select v-model="cust.customerType">
              <option value="Company">Företag</option>
              <option value="PrivatePerson">Privatperson</option>
            </select>
          </div>
        </div>

        <template v-if="cust.customerType == 'Company'">
          <div class="field">
            <label class="label">Org. nr. *</label>
            <input class="input" type="text" v-model="cust.organizationNumber" @blur="setVatNumber()" />
          </div>

          <div class="field">
            <label class="label">Momsregistreringsnummer *</label>
            <input class="input" type="text" v-model="cust.vatNumber" />
          </div>
        </template>

        <div class="field">
          <label class="label">Betalningsvillkor (dagar)</label>
          <input class="input" type="number" v-model.number="cust.paymentTermDays" />
        </div>

        <!-- <div class="field">
          <label class="label">Vår referens</label>
          <input class="input" type="email" v-model="cust.ourReference" />
        </div>

        <div class="field">
          <label class="label">Er referens</label>
          <input class="input" type="email" v-model="cust.yourReference" />
        </div> -->

        <div class="field">
          <label class="label">E-post för faktura *</label>
          <input class="input" type="email" v-model="cust.invoiceEmail" />
        </div>

        <div class="field">
          <label class="label">Distributionssätt faktura</label>
          <div class="select">
            <select v-model="cust.invoiceDeliveryType" placeholder="Välj distributionssätt...">
              <option value="Email">Email</option>
              <option value="ElectronicInvoice">E-faktura</option>
              <option value="Print">Utskrift</option>
              <option value="PrintService">Utskriftsservice</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Kundnummer Fortnox</label>
          <input class="input" type="text" v-model="cust.fortnoxCustomerNumber" :disabled="!id" />
        </div>

        <div class="field"></div>

        <div class="field">
          <h4>Adresser</h4>
        </div>

        <div class="field"></div>

        <div class="field">
          <div class="mrc-tabs">
            <div class="mrc-tab" :class="{ 'active': addressTab == 'mainAddress' }" @click="addressTab = 'mainAddress'">Fakturaaddress</div>
            <div class="mrc-tab" :class="{ 'active': addressTab == 'deliveryAddress' }" @click="addressTab = 'deliveryAddress'">Leveransadress</div>
          </div>
        </div>

        <div class="field"></div>

        <template v-if="addressTab == 'mainAddress'">
          <div class="field">
            <!-- <label class="label">Fakturaadress</label> -->
            <div class="is-flex">
              <div class="select is-inline-input">
                <select v-model="cust.mainAddressId">
                  <option value="null" selected>Välj fakturaadress...</option>
                  <option v-for="address in mainAddressList" :key="address.value" :value="address.value">{{ address.text }}</option>
                </select>
              </div>
              <button class="button is-inline-button is-info" @click="openAddressModal('Fakturaadress')"><i class="fal fa-plus"></i></button>
            </div>
          </div>
        </template>
        <template v-if="addressTab == 'deliveryAddress'">
          <div class="field">
            <!-- <label class="label">Leveransadress</label> -->
            <div class="is-flex">
              <div class="select is-inline-input">
                <select v-model="cust.deliveryAddressId">
                  <option value="null" selected>Välj leveransadress...</option>
                  <option v-for="address in deliveryAddressList" :key="address.value" :value="address.value">{{ address.text }}</option>
                </select>
              </div>
              <!-- <button class="button is-inline-button is-info" @click="openAddressModal('Leveransadress')"><i class="fal fa-plus"></i></button> -->
              <button class="button is-inline-button is-info" @click="openAddressModal('Objekt')"><i class="fal fa-plus"></i></button>
            </div>
          </div>
        </template>

        <div class="field"></div>

        <div class="field">
          <h4>Övrigt</h4>
        </div>

        <div class="field"></div>

        <div class="field">
          <label class="label">&nbsp;</label>
          <input id="payment-remark" type="checkbox" name="paymentRemark" v-model="cust.paymentRemark" class="switch is-rounded" checked="checked">
          <label for="payment-remark" class="label">Betalningsanmärkning</label>
        </div>

        <div class="field"></div>

        <div class="field">
          <h4>Fakturarutin</h4>
        </div>

        <div class="field"></div>

        <div class="field-full">
          <!-- <h4>Fakturarutin</h4> -->
          <!-- <label class="label">Fakturarutin</label> -->
          <textarea class="textarea"  v-model="cust.invoiceText"></textarea>
        </div>
      </div>

      <div class="required-message">* obligatoriskt fält</div>

      <modal-layout-buttons :store-name="'customers'" />

    </div>
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import AddressModal from '@/components/modals/AddressModal'

export default {
  name: 'customer-modal',
  data () {
    return {
      cust: {
        name: '',
        organizationNumber: null,
        vatNumber: null,
        paymentTermDays: 30,
        customerType: 'Company',
        ourReference: null,
        yourReference: null,
        invoiceEmail: null,
        invoiceText: null,
        invoiceDeliveryType: 'Email',
        mainAddressId: null,
        deliveryAddressId: null,
        newMainAddress: {},
        newDeliveryAddress: {}
      },
      addressTab: 'mainAddress',
      submitted: false,
      mainAddressList: [],
      deliveryAddressList: [],
      display: false
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapState({
      customers: state => state.customers.all
    }),
    title: function () {
      if (!this.id) {
        return 'Lägg till ny kund'
      } else {
        return 'Redigera kund  ' + this.cust.name
      }
    }
  },
  methods: {
    ...mapActions('customers', ['update', 'create', 'getById']),
    ...mapActions('addresses', ['getAddressesByCustomerId']),

    setVatNumber () {
      if (this.cust.vatNumber) {
        console.log('vat is already set')
        return
      }

      console.log(`setting vatNumber based on org.nr.: ${this.cust.organizationNumber}`)

      let vatNumber = this.cust.organizationNumber.replace(/\D/g, '')

      console.log(`extracted org.nr.: ${vatNumber}`)

      if (vatNumber && vatNumber.length === 10) {
        this.cust.vatNumber = `SE${vatNumber}01`
      } else {
        console.log(`wrong length of org.nr. to set vatNumber: ${vatNumber.length}`)
      }
    },

    closePanel () {
      this.$emit('closePanel', { response: this.cust })
    },

    getFormattedAddress (address) {
      let parts = []

      if (address.address1) {
        parts.push(address.address1)
      }
      if (address.address2) {
        parts.push(address.address2)
      }
      if (address.postalCode || address.city) {
        parts.push(address.postalCode + ' ' + address.city)
      }
      return parts.join(', ')
    },

    openAddressModal (addressType) {
      this.$panel(AddressModal, { addressType: addressType, displayCustomer: false, saveAddress: false, preventListReload: true }).then(response => {
        if (response && response.response) {
          const address = response.response

          if (address.addressType === 'Fakturaadress') {
            const mainAddressDto = { value: 0, text: this.getFormattedAddress(address), addressType: address.addressType }
            this.mainAddressList = this.mainAddressList.filter(x => x.addressId === 0)
            this.mainAddressList.push(mainAddressDto)

            this.cust.mainAddressId = 0
            this.cust.newMainAddress = address
          } else if (address.addressType === 'Objekt') {
            const deliveryAddressDto = { value: 0, text: this.getFormattedAddress(address), addressType: address.addressType }
            this.deliveryAddressList = this.deliveryAddressList.filter(x => x.addressId === 0)
            this.deliveryAddressList.push(deliveryAddressDto)

            this.cust.deliveryAddressId = 0
            this.cust.newDeliveryAddress = address
          } else {
            alert('(' + address.addressType + ') Endast Fakturaadress och Objekt stöds för tillfället.')
          }
        }
      })
    },

    save () {
      this.submitted = true
      this.$validator.validateAll()

      if (this.id) {
        this.update(this.cust).then(response => {
          this.$emit('pageChange')
          this.closePanel()
        })
      } else {
        this.create(this.cust).then(customer => {
          this.cust = customer
          this.$emit('pageChange')
          this.closePanel()
        })
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    let promises = []

    if (this.id) {
      promises.push(this.getById(this.id).then(customer => {
        this.cust = customer.result
      }))

      promises.push(this.getAddressesByCustomerId(this.id).then(addresses => {
        if (addresses) {
          this.mainAddressList = addresses.filter(x => x.addressType === 'Fakturaadress').map(x => ({ text: x.formatted, value: x.addressId }))
          this.deliveryAddressList = addresses.filter(x => x.addressType === 'Objekt').map(x => ({ text: x.formatted, value: x.addressId }))
        }
      }))
    }

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>

<style scoped>
  .is-inline-input {
    flex-grow: 1;
  }
  .is-inline-button {
    text-align: right;
    margin-left: 5px;
  }
</style>

<style lang="scss">
  .mrc-tabs {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    gap: 1rem;
    color: #666;

    .mrc-tab {
      cursor: pointer;

      &.active {
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/CustomerModal.vue